<template lang="html">
	<!-- CINEMA -->
	<!-- <div>
		<b-modal ref="modelRef" class="promo-modal" hide-footer hide-header @hidden="onHidden">
			<div id="closeModal" @click="hideModal"></div>
			<div class="top-title">
				<p>{{ trad.header_text }}</p>
				<h3 class="content-title">{{ trad.header_title }}</h3>
				<p class="small">{{ trad.header_text_small }}</p>
			</div>
			<div class="logos">
				<div class="content">
					<img src="/img/modal/pathe.png" alt="Pathe" class="pathe">
					<img src="/img/modal/kinepolis.png" alt="Kinepolis" class="kinepolis">
					<img src="/img/modal/ugc.png" alt="UGC" class="ugc">
					<img src="/img/modal/imagix.png" alt="Imagix" class="imagix">
					<img src="/img/modal/euroscoop.png" alt="Euroscoop" class="euroscoop">
					<img src="/img/modal/michelin.png" alt="Michelin" class="michelin">
					<img src="/img/modal/gault.png" alt="Gault & Millau" class="gault">
				</div>
			</div>
			<div class="modal-container container-fluid">
				<div class="content">
					<div class="desktop top-content" :style="headerTop">
						<div class="title-cta">
							<h3 class="content-title">{{ trad.top_title }}</h3>
							<a href="javascript:void(0)" @click="goToOffers" class="btn btn-main">{{ trad.getit }}</a>
						</div>
					</div>
					<div class="mobile top-content" :style="headerTopMobile">
						<div class="title-cta">
							<a href="javascript:void(0)" @click="goToOffers" class="btn btn-main">{{ trad.getit }}</a>
							<h3 class="content-title">{{ trad.top_title }}</h3>
						</div>
					</div>
					<h3 class="content-title center">{{ trad.title }}</h3>
					<div class="texts">
						<div class="row">
							<div class="col-12 col-md-6">
								<p class="left" v-html="trad.colleft"></p>
							</div>
							<div class="col-12 col-md-6">
								<p class="right" v-html="trad.colright"></p>
							</div>
						</div>
					</div>
					<div class="cards">
						<div class="row">
							<div class="col-6 left">
								<a href="javascript:void(0)" @click="goToOffers">
									<p class="b" v-html="trad.priceclassic"></p>
									<img :src="card_classic" alt="classic">
								</a>
							</div>
							<div class="col-6 right">
								<a href="javascript:void(0)" @click="goToOffers">
									<p class="b" v-html="trad.pricegold"></p>
									<img :src="card_gold" alt="Gold">
								</a>
							</div>
						</div>
					</div>
					<div class="text-under">
						<p class="center">{{ trad.under_text }}</p>
					</div>
				</div>
			</div>
		</b-modal>
	</div> -->

	<!-- SOLDES -->
	<!-- <div>
		<b-modal ref="modelRef" class="promo-modal" hide-footer hide-header @hidden="onHidden">
			<div id="closeModal" @click="hideModal"></div>
			<div class="top-title">
				<h3 class="content-title center">{{ trad.header_title }}</h3>
			</div>
			<div class="modal-container container-fluid">
				<div class="content">
					<div class="desktop top-content" :style="headerTop">
						<div class="title-cta">
							<h3 class="content-title">{{ trad.top_title }}</h3>
							<a href="javascript:void(0)" @click="goToOffers" class="btn btn-main">{{ trad.getit }}</a>
						</div>
					</div>
					<div class="mobile top-content" :style="headerTopMobile">
						<div class="title-cta">
							<a href="javascript:void(0)" @click="goToOffers" class="btn btn-main">{{ trad.getit }}</a>
							<h3 class="content-title">{{ trad.top_title }}</h3>
						</div>
					</div>
					<h3 class="content-title center">{{ trad.title }}</h3>
					<div class="cards">
						<div class="row">
							<div class="col-6 left">
								<a href="javascript:void(0)" @click="goToOffers">
									<p class="b" v-html="trad.priceclassic"></p>
									<img srcset="/img/discount/summer19/black@2x.jpg 2x, /img/discount/summer19/black.jpg 1x" src="/img/discount/summer19/black.jpg" alt="classic">
								</a>
							</div>
							<div class="col-6 right">
								<a href="javascript:void(0)" @click="goToOffers">
									<p class="b" v-html="trad.pricegold"></p>
									<img srcset="/img/discount/summer19/gold@2x.jpg 2x, /img/discount/summer19/gold.jpg 1x" src="/img/discount/summer19/gold.jpg" alt="Gold">
								</a>
							</div>
						</div>
					</div>
					<div class="texts">
						<div class="row">
							<div class="col-12 col-md-6">
								<p class="left" v-html="trad.colleft"></p>
							</div>
							<div class="col-12 col-md-6">
								<p class="right" v-html="trad.colright"></p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="footer">
				<div class="content">
					<img src="/img/modal/kinepolis.png" alt="Kinepolis" class="kinepolis">
					<img src="/img/modal/ugc.png" alt="UGC" class="ugc">
					<img src="/img/modal/imagix.png" alt="Imagix" class="imagix">
					<img src="/img/modal/michelin.png" alt="Michelin" class="michelin">
					<img src="/img/modal/gault.png" alt="Gault & Millau" class="gault">
				</div>
			</div>
		</b-modal>
	</div> -->
	<div>
		<b-modal ref="modelRef" class="promo-modal" hide-footer hide-header @hidden="onHidden">
			<div id="closeModal" @click="hideModal"></div>
			<div class="modal-container container-fluid">
				<div class="content">
					<div v-html="trad.header_text"></div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
export default {
	name: 'ModalView',

	props: {

		route: {
			required: true
		},
		locale: {
			default: 'fr',
		},
		trad: {
			required: true
		},

	},

	data () {
		return {
			// CINEMA
			// headerTop: 'background: url(\'/img/modal/background_top_'+this.locale+'.png\') no-repeat top center;',
			// headerTopMobile: 'background: url(\'/img/modal/mobile_background_top_'+this.locale+'.png\') no-repeat top center;',
			// card_classic: '/img/modal/classic_'+this.locale+'.jpg',
			// card_gold: '/img/modal/gold_'+this.locale+'.jpg'

			// SOLDES
			headerTop: 'background: url(\'/img/discount/summer19/background_top_'+this.locale+'.png\') no-repeat top center;',
			headerTopMobile: 'background: url(\'/img/discount/summer19/mobile_background_top_'+this.locale+'.png\') no-repeat top center;'
		}
	},

	mounted() {
		if(this.$cookies.get('modal') !== '1') {
			this.show()
		}
	},

	methods: {
		show() {
			document.body.classList.add("no-scroll")
			document.getElementById('contentx').classList.add("pointer-none")
			document.getElementById('footer').classList.add("pointer-none")
			document.getElementById('app').classList.add("no-scroll")
			this.$refs.modelRef.show()
		},
		hideModal() {
			this.$cookies.set('modal', 1)
			this.$refs.modelRef.hide()
		},
		goToOffers() {
			this.$cookies.set('modal', 1)
			this.$refs.modelRef.hide()
			window.location.href = this.route;
		},
		onHidden() {
			document.body.classList.remove("no-scroll")
			document.getElementById('contentx').classList.remove("pointer-none")
			document.getElementById('footer').classList.remove("pointer-none")
			document.getElementById('app').classList.remove("no-scroll")
			this.$cookies.set('modal', 1)
		}
	}

}
</script>


<script>
export default {
	name: 'ModalView',

	props: {

		route: {
			required: true
		},
		locale: {
			default: 'fr',
		},
		trad: {
			required: true
		},

	},

	data () {
		return {
			headerTop: 'background: url(\'/img/discount/summer19/background_top_'+this.locale+'.png\') no-repeat top center;',
			headerTopMobile: 'background: url(\'/img/discount/summer19/mobile_background_top_'+this.locale+'.png\') no-repeat top center;'
		}
	},

	mounted() {
		if(this.$cookies.get('modal') !== '1') {
			this.show()
		}
	},

	methods: {
		show() {
			document.body.classList.add("no-scroll")
			document.getElementById('contentx').classList.add("pointer-none")
			document.getElementById('footer').classList.add("pointer-none")
			document.getElementById('app').classList.add("no-scroll")
			this.$refs.modelRef.show()
		},
		hideModal() {
			this.$cookies.set('modal', 1)
			this.$refs.modelRef.hide()
		},
		goToOffers() {
			this.$cookies.set('modal', 1)
			this.$refs.modelRef.hide()
			window.location.href = this.route;
		},
		onHidden() {
			document.body.classList.remove("no-scroll")
			document.getElementById('contentx').classList.remove("pointer-none")
			document.getElementById('footer').classList.remove("pointer-none")
			document.getElementById('app').classList.remove("no-scroll")
			this.$cookies.set('modal', 1)
		}
	}

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ModalView.vue